import type { BadStatusError } from '@confluence/network';
import {
	RelayError as ApolloErrorInterop,
	createGraphQLError as createInteropGraphQLError,
} from '@confluence/relay-errors/entry-points/RelayError.ts';

export const convertToApolloError = (error: Error | BadStatusError): ApolloErrorInterop => {
	const message = error.message || 'Unknown error';
	const status = 'response' in error ? error.response?.status : undefined;

	return new ApolloErrorInterop({
		graphQLErrors: [createGraphQLError({ message, status, originalError: error })],
	});
};

const createGraphQLError = ({
	message,
	status,
	originalError,
}: {
	message: string;
	status: number | undefined;
	originalError: Error;
}) => {
	const extensions = status
		? {
				statusCode: status,
				http: { status },
			}
		: undefined;

	return createInteropGraphQLError(message, {
		path: null,
		originalError,
		extensions,
	});
};
